/**
 * Customer 欄位中文顯示名稱（REQ-20260419005）。
 * 供排序下拉、搜尋 Modal 等 UI 共用。
 * `phone` 為搜尋用虛擬欄位（REQ-20260421001），不在 sortable 白名單。
 */
import type {
  CustomerSearchableField,
  CustomerSortableField,
} from '@app/shared';

export const CUSTOMER_FIELD_LABELS: Record<
  CustomerSearchableField | CustomerSortableField,
  string
> = {
  phone: '電話',
  cCode: '客戶編號',
  simpleName: '公司簡稱',
  fullName: '公司全名',
  tax: '統一編號',
  contact: '聯絡人',
  mobile: '行動',
  email: 'Email',
  address: '公司地址',
  id: '內部 ID',
  createdAt: '建立時間',
  updatedAt: '更新時間',
};
